"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Wizard = require("../Wizard/Wizard.js");
var _FinancialPlanningCheckupWizardTool = require("./FinancialPlanningCheckupWizardTool.config");
var _ProgressBarStepList = _interopRequireDefault(require("../Wizard/ProgressBarStepList"));
var _axios = _interopRequireDefault(require("axios"));
var _CalculatorTemplate = require("../Wizard/CalculatorTemplate");
var _utils = require("../../middleware/utils");
var _FPCTPageOne = _interopRequireDefault(require("./FPCTPageOne"));
var _FPCTPageTwo = _interopRequireDefault(require("./FPCTPageTwo"));
var _FPCTPageThree = _interopRequireDefault(require("./FPCTPageThree"));
var _FPCTPageFour = _interopRequireDefault(require("./FPCTPageFour"));
var _PageFourSideContent = _interopRequireDefault(require("./ForcedSideContent/PageFourSideContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

var FinancialPlanningCheckupWizardTool = props => {
  var {
    config
  } = props;
  var [stepNumber, setStepNumber] = (0, _react.useState)(0);
  // const [snapshot, setSnapshot] = useState({})
  var currentConfig = config.Steps[stepNumber];

  // Disclosure modal handler here
  var [showDisclosureModal, setShowDisclosureModal] = (0, _react.useState)(false);
  var disclosureHandleClose = () => {
    setShowDisclosureModal(false);
  };
  var disclosureHandleShow = () => {
    (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'disclosure');
    setShowDisclosureModal(true);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: _FinancialPlanningCheckupWizardTool.calcName
  }, /*#__PURE__*/_react.default.createElement(_CalculatorTemplate.CalculatorTemplate, {
    config: config,
    currentConfig: currentConfig,
    stepNumber: stepNumber,
    customSideContent: [null, null, null, /*#__PURE__*/_react.default.createElement(_PageFourSideContent.default, {
      key: 4
    })]
  }, /*#__PURE__*/_react.default.createElement(_ProgressBarStepList.default, {
    activeStep: stepNumber + 1,
    steps: 4,
    detailedStepper: true,
    stepTitle: ['Goals', 'Assessment', 'Analysis', 'Connect & download']
  }), /*#__PURE__*/_react.default.createElement(_Wizard.Wizard, {
    passthroughId: "FinancialPlanningCheckupWizardTool",
    setStepNumber: setStepNumber,
    stepNumber: stepNumber,
    initialValues: _FinancialPlanningCheckupWizardTool.initialValuesConfig,
    initialTouched: _FinancialPlanningCheckupWizardTool.initialTouchedConfig,
    onSubmit: () => {},
    currentConfig: currentConfig
    // validationData={validationData}
    // errorData={errorData}
    ,
    calcName: _FinancialPlanningCheckupWizardTool.calcName,
    maxSteps: 4,
    isNotNatLang: [true, true, true, true],
    centerNavButtons: [false, false, false, false]
  }, /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _FinancialPlanningCheckupWizardTool.validationConfig[0]
  }, /*#__PURE__*/_react.default.createElement(_FPCTPageOne.default, null)), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _FinancialPlanningCheckupWizardTool.validationConfig[1]
  }, /*#__PURE__*/_react.default.createElement(_FPCTPageTwo.default, null)), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _FinancialPlanningCheckupWizardTool.validationConfig[2],
    sideButtonOnClick: disclosureHandleShow
  }, /*#__PURE__*/_react.default.createElement(_FPCTPageThree.default, {
    disclosureHandleClose: disclosureHandleClose,
    showDisclosure: showDisclosureModal
  })), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _FinancialPlanningCheckupWizardTool.validationConfig[3]
  }, /*#__PURE__*/_react.default.createElement(_FPCTPageFour.default, null)))));
};
var _default = exports.default = FinancialPlanningCheckupWizardTool;